import React, { useContext } from 'react';
import S from "./MSStyleBox";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import TableStyle from "../../../Table/Table";
import Table from '../../../Table';

import StyleBox1 from "@/assets/stylebox/StyleBox_Equity_1.svg";
import StyleBox2 from "@/assets/stylebox/StyleBox_Equity_2.svg";
import StyleBox3 from "@/assets/stylebox/StyleBox_Equity_3.svg";
import StyleBox4 from "@/assets/stylebox/StyleBox_Equity_4.svg";
import StyleBox5 from "@/assets/stylebox/StyleBox_Equity_5.svg";
import StyleBox6 from "@/assets/stylebox/StyleBox_Equity_6.svg";
import StyleBox7 from "@/assets/stylebox/StyleBox_Equity_7.svg";
import StyleBox8 from "@/assets/stylebox/StyleBox_Equity_8.svg";
import StyleBox9 from "@/assets/stylebox/StyleBox_Equity_9.svg";

const styleBoxImages: Record<number, string> = {
  1: StyleBox1,
  2: StyleBox2,
  3: StyleBox3,
  4: StyleBox4,
  5: StyleBox5,
  6: StyleBox6,
  7: StyleBox7,
  8: StyleBox8,
  9: StyleBox9,
};

const MSStyleBox: React.FC<FundSingle> = () => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    const styleBox = fundRiskDetails.Portfolios[0].EquityStatistics.StyleBox;
    const StyleBoxImage = styleBoxImages[styleBox];

    return (
        <S.AllocationWrapper>
            <CardHeader title="Morningstar style box®" />
            <S.MSStyleBoxHeader>Investeringsstil Aktier</S.MSStyleBoxHeader>
            <S.MSStyleBox><StyleBoxImage className="custom-stylebox"></StyleBoxImage></S.MSStyleBox>
        </S.AllocationWrapper>
    );
};

export default MSStyleBox;
